import { Component, OnInit} from '@angular/core';

interface ItemData2 {
  name: string;
  age: string;
  address: string;
}

@Component({
  selector: 'app-company-type',
  templateUrl: './company-type.component.html',
  styleUrls: ['./company-type.component.scss']
})
export class CompanyTypeComponent implements OnInit {

  listOfData2: ItemData2[] = [];
  value?: string;

  constructor() {}

  ngOnInit(): void {
    for (let i = 0; i < 100; i++) {
      this.listOfData2.push({
        name: `${i}`,
        age: 'Kalubhai',
        address: 'General'
      });
    }
  }
}